import {useProductValidation} from 'hooks/validator';

export function useHomeSafeValidation() {
  const {addProductValidation} = useProductValidation({
    wrapProductData: (calculation, product) => ({
      State: calculation.State,
      productMetric: calculation.HomeSafeMetric,
      productAvailableStates: product.ProductAvailableStates,
    }),
  });

  return {addProductValidation};
}
